import { routes } from '@/domains/core/routing/routes/routes.default';
import { NavigationButton } from '@/domains/core/tamagoshiTailwind/components/NavigationButton/NavigationButton';
import { Typography } from '@/domains/core/tamagoshiTailwind/components/Typography/Typography';
import { SymbolGoldIcon } from '@/domains/core/tamagoshiTailwind/icons/SymbolGoldIcon';
import { SuperProMulticolorDarkSLogo } from '@/domains/core/tamagoshiTailwind/logos/superPro/SuperProMulticolorDarkSLogo';
import { loyaltyProgramAfterSalesService, loyaltyProgramCart, loyaltyProgramCashbackPercentage, loyaltyProgramFlashPromos, loyaltyProgramGoldStatus } from '@/domains/loyalty/modules/LoyaltyProgram/translations';
import { formatPercentage } from '@/domains/loyalty/utils/translate/formatters';
import { knowMore } from '@/domains/productDiscovery/ProductPage/translations';
import { LoyaltyLevelName } from '@/generated/graphql/types';
export const GoldAdvantages = () => <div className="flex h-full flex-col rounded-container bg-accent-secondary p-m">
    <div className="flex">
      <Typography scale="body2" weight="bold">
        {loyaltyProgramGoldStatus.format({
        icon: <SymbolGoldIcon />
      })}
      </Typography>
      <SuperProMulticolorDarkSLogo className="h-m" />
    </div>
    <ul>
      <li>
        {`• ${loyaltyProgramCashbackPercentage.format(formatPercentage({
        percentage: 3,
        loyaltyLevelName: LoyaltyLevelName.GOLD
      }))}`}
      </li>
      <li>{loyaltyProgramFlashPromos}</li>
      <li>{loyaltyProgramAfterSalesService}</li>
      <li>{loyaltyProgramCart}</li>
    </ul>
    <div className="mt-auto self-end">
      <NavigationButton href={(routes as Record<string, string>).mySpaceAdvantages} size="M" text={knowMore} title={knowMore} variant="link" />
    </div>
  </div>;
GoldAdvantages.displayName = 'GoldAdvantages';